<script setup lang="ts">
import useVueformResponseErrors from 'vueform/src/VueformResponseErrors';
import {ref} from 'vue'
import type {Ref} from 'vue'
import type {JText} from 'joomla/joomla.interface';

let completed: Ref<boolean> = ref(false)

function success(): void {
  document.querySelector<HTMLElement>('#become-detective-success')!.style.display = 'block'
  document.querySelector<HTMLElement>('.become-detective .intro')!.style.display = 'none'
  completed.value = true
}

const privacyPolicy: string = Joomla.getOptions('configuration').cukmensBecomeDetectivePrivacyPolicy
const jText: JText = Joomla.JText

</script>

<template>
  <Vueform ref="form" v-if="!completed" form-key="become-detective" @success="success"
           @response="useVueformResponseErrors as any" :add-classes="{GroupElement:{container: 'group-element'}}">
    <GroupElement name="kindergarten" label="Bērnudārzs">
      <TextElement name="kindergarten_name" label="Nosaukums" rules="required" :columns="{
  default: 12,
  md: 6,
}"/>
      <TextElement name="group_name" label="Grupiņas nosaukums" rules="required" :columns="{
  default: 12,
  md: 4,
}"/>
      <TextElement name="number_of_detectives" label="Dalībnieku skaits" rules="required|numeric|min:1" :attrs="{
        min: '1',
      }" input-type="number"
                   :columns="{
  default: 12,
  md: 2,
}"/>
      <TextElement name="address" label="Adrese" size="lg"
                   :placeholder="jText._('MOD_REACTIVE_FORMS_CUKMENS_BECOME_DETECTIVE_ATTRIBUTE_PLACEHOLDER_ADDRESS')"
                   rules="required|min:15" :columns="{
  default: 12,
  md: 5,
}"/>
    </GroupElement>
    <GroupElement name="contact" label="Kontaktpersona">
      <TextElement name="contact_person_full_name" label="Vārds, uzvārds" rules="required" :columns="{
  default: 12,
  md: 3,
}"/>
      <TextElement name="contact_person_job_title" label="Amats" rules="required" :columns="{
  default: 12,
  md: 2,
}"/>
      <TextElement name="contact_person_email" label="E-pasts" input-type="email" :columns="{
  default: 12,
  md: 4,
}"
                   rules="required|email:debounce=1000"/>
      <TextElement name="contact_person_phone" :add-class="{input: ['tel']}" label="Tālrunis"
                   rules="required|digits:8"
                   input-type="number"
                   :addons="{
            before: '+371',
          }" :columns="{
  default: 12,
  md: 3
}"/>
    </GroupElement>
    <TextareaElement
        name="motivation"
        label="Motivācija"
        rules="required"
    />
    <CheckboxElement
        name="privatuma_politika"
        :text="privacyPolicy"
        rules="required"
    />
    <CaptchaElement name="g_recaptcha_response"/>
    <ButtonElement
        name="submit"
        button-label="Pieteikties"
        :submits="true"
        align="center"
        :add-class="{button: ['btn']}"
    />
  </Vueform>
</template>
<style lang="scss">
input[type=number].tel {
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;
}
</style>
